import { ObjectValues } from './type-helper';

export const ObjectTypes = {
  DOSSIER: 'Dossier',
  FEE: 'Fee',
  GOOD: 'Good',
  COMPANY: 'Company',
  COUNTRY: 'Country',
  CONTACT: 'Contact',
  FILE_NUMBER: 'FileNumber',
  COLLATERAL_CLAUSE: 'CollateralClause',
  LOG_TEMPLATE: 'LogTemplate',
  CHOICE: 'Choice',
  DOSSIER_IDENTIFIER: 'DossierIdentifier',
  DOSSIER_DATE: 'DossierDate',
  DOSSIER_GOOD: 'DossierGood',
  DOSSIER_PARTY: 'DossierParty',
  DOSSIER_VOTE: 'DossierVote',
  DOSSIER_TRANSPORTATION: 'DossierTransportation',
} as const;

export type ObjectType = ObjectValues<typeof ObjectTypes>;
